import { createContext } from "react";

export default createContext({
  showToast: () => {},
  hideToast: () => {},
  showSuccessToast: () => {},
  showErrorToast: () => {},
  showWarningToast: () => {},
  showInfoToast: () => {},
});